const insertHeadElement = ({
  printBody,
  tagName,
  text,
  media,
}: {
  printBody: Document;
  tagName: 'style';
  text: string;
  media?: 'print';
}) => {
  const tagElement = printBody.createElement(tagName);
  if (media) tagElement.media = media;
  tagElement.appendChild(printBody.createTextNode(text));
  printBody.head.appendChild(tagElement);
};

export { insertHeadElement };
